export default "__VITE_ASSET__8ZVDNZto__"